import { GraduationCap, Sparkles, ArrowUpRight, MessageCircle } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/Reveal";
import { CONFIG } from "@/lib/data";

const GROWTH_WA = `https://wa.me/${CONFIG.whatsapp}?text=${encodeURIComponent("Hi Sanvalio! I want to book the ₹999 Growth Call + Free Brand/Website Audit for my business.")}`;

export const EcosystemLinks = () => (
  <section id="ecosystem" className="relative mx-auto max-w-[1400px] px-6 sm:px-10 py-20 lg:py-28">
    <Reveal>
      <SectionLabel>Explore more</SectionLabel>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.02] max-w-3xl">
        More from the <span className="text-gradient">Sanvalio universe.</span>
      </h2>
    </Reveal>
    <div className="mt-12 grid gap-6 md:grid-cols-2">
      <Reveal>
        <div data-testid="ecosystem-card-growth" className="group relative flex h-full flex-col rounded-3xl glass p-8 sm:p-10 hover-card-glow overflow-hidden">
          <span className="absolute -top-16 -right-16 h-48 w-48 rounded-full bg-[var(--accent-primary)] opacity-[0.08] blur-3xl group-hover:opacity-[0.16] transition-opacity" />
          <span className="inline-flex w-fit items-center gap-2 rounded-full btn-accent px-4 py-1.5 font-heading text-xs font-bold uppercase tracking-[0.12em]">
            Free Audit + Growth Call @ ₹999
          </span>
          <span className="mt-6 flex items-center gap-4">
            <span className="grid h-12 w-12 place-items-center rounded-2xl border border-[var(--border-subtle)] text-[var(--accent-primary)]">
              <Sparkles size={24} />
            </span>
            <span className="font-display text-2xl sm:text-3xl font-bold">Sanvalio Growth</span>
          </span>
          <p className="mt-4 font-body text-[var(--text-secondary)] leading-relaxed flex-1">
            Get a free brand &amp; website audit plus a 1:1 growth strategy call for just ₹999 — a clear, actionable roadmap for your business.
          </p>
          <div className="mt-7 flex flex-wrap items-center gap-4">
            <a href={GROWTH_WA} target="_blank" rel="noopener noreferrer" data-testid="growth-whatsapp-book-btn"
               className="btn-accent inline-flex items-center gap-2 rounded-full px-7 py-3.5 font-heading font-semibold">
              <MessageCircle size={18} />
              Book on WhatsApp
            </a>
            <a href="https://www.sanvalio.in" target="_blank" rel="noopener noreferrer" data-testid="ecosystem-link-growth"
               className="group/l inline-flex items-center gap-2 font-heading font-semibold text-[var(--accent-primary)]">
              Visit sanvalio.in
              <ArrowUpRight size={18} className="group-hover/l:translate-x-1 group-hover/l:-translate-y-1 transition-transform" />
            </a>
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.12}>
        <a href="https://www.sanvalioacademy.com" target="_blank" rel="noopener noreferrer" data-testid="ecosystem-link-academy"
           className="group relative flex h-full flex-col rounded-3xl glass p-8 sm:p-10 hover-card-glow overflow-hidden">
          <span className="absolute -top-16 -right-16 h-48 w-48 rounded-full bg-[var(--accent-primary)] opacity-[0.08] blur-3xl group-hover:opacity-[0.16] transition-opacity" />
          <span className="inline-flex w-fit items-center gap-2 rounded-full btn-accent px-4 py-1.5 font-heading text-xs font-bold uppercase tracking-[0.12em]">
            Learn with us
          </span>
          <span className="mt-6 flex items-center gap-4">
            <span className="grid h-12 w-12 place-items-center rounded-2xl border border-[var(--border-subtle)] text-[var(--accent-primary)]">
              <GraduationCap size={24} />
            </span>
            <span className="font-display text-2xl sm:text-3xl font-bold">Sanvalio Academy</span>
          </span>
          <p className="mt-4 font-body text-[var(--text-secondary)] leading-relaxed flex-1">
            Master branding, marketing and creative skills with hands-on courses from the Sanvalio team.
          </p>
          <span className="mt-7 inline-flex items-center gap-2 font-heading font-semibold text-[var(--accent-primary)]">
            Visit sanvalioacademy.com
            <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
          </span>
        </a>
      </Reveal>
    </div>
  </section>
);
